// extracted by mini-css-extract-plugin
module.exports = {"Container":"NavBar_Container__5Z5oI","Overlay":"NavBar_Overlay__Jzvec","SideMenu":"NavBar_SideMenu__M8w1g","Background":"NavBar_Background__L9ZNs"};